/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APITicketAutocompleteSuggestion } from './APITicketAutocompleteSuggestion';
import {
    APITicketAutocompleteSuggestionFromJSON,
    APITicketAutocompleteSuggestionFromJSONTyped,
    APITicketAutocompleteSuggestionToJSON,
} from './APITicketAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APITicketAutocompleteResponse
 */
export interface APITicketAutocompleteResponse {
    /**
     * 
     * @type {Array<APITicketAutocompleteSuggestion>}
     * @memberof APITicketAutocompleteResponse
     */
    suggestions: Array<APITicketAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APITicketAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APITicketAutocompleteResponse interface.
 */
export function instanceOfAPITicketAutocompleteResponse(value: object): value is APITicketAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APITicketAutocompleteResponseFromJSON(json: any): APITicketAutocompleteResponse {
    return APITicketAutocompleteResponseFromJSONTyped(json, false);
}

export function APITicketAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicketAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APITicketAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APITicketAutocompleteResponseToJSON(value?: APITicketAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APITicketAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

